import { render, staticRenderFns } from "./RelatorioLogSolicitacoesAcesso.vue?vue&type=template&id=08e0eb68"
import script from "./RelatorioLogSolicitacoesAcesso.vue?vue&type=script&lang=js"
export * from "./RelatorioLogSolicitacoesAcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports